import { ShopModel } from '@warema/shared/shop/shared/models';

export interface CartItem {
    id: string;
    name: string;
    articleNr: string;
    imgUrl: string;
    productType: ProductType;
    productDetails: ShopModel;
}

export interface CartPosition {
    item: CartItem;
    quantity: number;
    invalid: boolean;
}

export interface Cart {
    id: string;
    positions: Array<CartPosition>;
    quantity: number;
    cartDate: Date;
}

export enum ProductType {
    UNKNOWN = 'unknown',
    FABRIC = 'fabric',
    BROCHURE = 'brochure',
    SLAT = 'slat',
}

export enum CartValidationResult {
    VALID = 0,
    MAX_FABRIC_ERROR = 1,
}
